export default __webpack_public_path__ + "static/media/play-button-icon-png-18931.9c330199.png";